import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Countdown from '../../components/CountdownGame3';
import DropTasks from "../../components/DropTasks";

// Rounds
@inject('Game3Store')
@observer
export default class Game3Step5 extends Component {


    static defaultProps = {
        onShowGuidelines: () => {},
    };

    constructor(props) {
        props.Game3Store.setPlayersTurn();
        super(props);
    }

    componentDidUpdate() {
        const btns = document.querySelectorAll(".btn-answer");
        for (let bt of btns) {
            bt.className = "btn-answer";
        }

        const btnNavNext = document.querySelector(".btn-nav-next");
        btnNavNext.className = "btn-nav-next disabled";
    }

    addPointsToScore(index, player, e) {

        let points = e.points;

        player.tasks[index]['choice'] = e.label;

        player.tasks[index]['hasResponse'] = true;

        if( player.tasks[index]['point'] === undefined ) {
            player.score += points;
            player.tasks[index]['point'] = points;
        } else if ( player.tasks[index]['point'] !== undefined ) {
            player.score = player.score - player.tasks[index]['point'];
            player.score += points;
            player.tasks[index]['point'] = points;
        }


        let drops = document.querySelectorAll(".dropdown-selected");

        setTimeout(function () {
            let libera = true;

            for (let i = 0; i < drops.length; i++) {
                let val = drops[i].innerHTML;
                if ( val.length < 3 ) {
                    libera = false;
                }
            }

            if ( libera ) {
                const btnNavNext = document.querySelector(".btn-nav-next");
                btnNavNext.className = "btn-nav-next";
            }
        },100);


        const btns = document.querySelectorAll(".btn-answer");
        for (let bt of btns) {
            if (bt.name === "btn" + index) {
                if( bt.className == "btn-answer selected" ) {
                    bt.className = "btn-answer";
                    this.selected = false;
                    this.props.Game3Store.pause = false;
                    this.props.Game3Store.start = true;
                } else {
                    bt.className = "btn-answer selected";
                    this.selected = true;
                    this.props.Game3Store.pause = true;
                    this.props.Game3Store.start = false;
                }

                const btnNavNext = document.querySelector(".btn-nav-next");
                if( !this.selected ) {
                    btnNavNext.className = "btn-nav-next disabled";
                } else {
                    btnNavNext.className = "btn-nav-next";
                }
            } else {
                bt.className = "btn-answer";
            }
        }
    }

    showGuidelines(e) {
        this.props.onShowGuidelines();
    }

    render() {

        let answers = this.props.Game3Store.answers;

        let players = this.props.Game3Store.players;

        let _this = this;

        var taskEl = [];

        players.forEach(function(player){

            const dropdowns = player.tasks.map(
                (task, index) =>
                <DropTasks
                    key={index}
                    items={answers}
                    selectedItem={task.choice ? task.choice : ""}
                    nullOption=""
                    index={index}
                    onChange={_this.addPointsToScore.bind(_this, index, player)}
                />
            );

            taskEl.push(
                <div className="team-name" key={player.name}>
                    <label className={player.team.color}>{player.name}</label>
                    <br/>
                    <div className="dropdown-flex">
                        {dropdowns}
                    </div>
                    <br/>
                </div>
            );

        });

        return (
            <div className="step-4">
                <h1>Game</h1>
                <Countdown minutes={10} seconds={1}/>
                <div className="button-guideline">
                    <button className="timer" onClick={this.showGuidelines.bind(this)}>Guidelines</button>
                </div>
                <div className="teams">
                {taskEl}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Game3/Game3Step5.js